var render = function render(){var _vm=this,_c=_vm._self._c;return _c('configPromocionesFile',{on:{"refrest":_vm.close}})
}
var staticRenderFns = []

export { render, staticRenderFns }